@if (block(); as genericBlock) {
  <div [attr.data-testid]="'footer-block-' + genericBlock.id" class="p-5">
    @if (genericBlock.headlines | language) {
      <div
        class="mb-2 font-medium uppercase"
        [attr.aria-label]="genericBlock.headlines | language">
        {{ genericBlock.headlines | language }}
      </div>
    }
    @switch (genericBlock.type) {
      @case (FooterBlockType.Text) {
        <quill-view
          [content]="genericBlock.texts | language"
          format="json"
          theme="snow"></quill-view>
      }
      @case (FooterBlockType.Links) {
        @for (link of genericBlock.links; track link.id) {
          @let url = link.texts | filterTexts: RelationType.url | language;
          @if (url) {
            <a
              class="hover:text-primary-main block hover:underline"
              [href]="url">
              {{ link.texts | filterTexts: RelationType.text | language }}
            </a>
          } @else {
            <span>{{
              link.texts | filterTexts: RelationType.text | language
            }}</span>
          }
        }
      }
      @case (FooterBlockType.Logo) {
        @let logoImage = genericBlock.accessibleImages[0];
        @if (logoImage && logoImage.image) {
          @if (logoImage.url) {
            <a
              class="my-3 inline-block"
              [href]="logoImage.url"
              ><img
                class="block h-auto max-h-8"
                [alt]="logoImage.imageAlts | language"
                [src]="
                  footerStore.requestPath(logoImage.id, genericBlock.id ?? '')
                "
            /></a>
          } @else {
            <span class="my-3 inline-block"
              ><img
                class="block h-auto max-h-8"
                [alt]="logoImage.imageAlts | language"
                [src]="
                  footerStore.requestPath(logoImage.id, genericBlock.id ?? '')
                "
            /></span>
          }
        }
      }
      @default {
        <div
          class="flex"
          [class.flex-col]="(genericBlock.orientation ?? 'vertical') === 'vertical'"
          [class.flex-row]="genericBlock.orientation === 'horizontal'"
          [class.flex-wrap]="genericBlock.orientation === 'horizontal'"
          [class.gap-3]="true">
          @for (image of genericBlock.accessibleImages; track image.id) {
            @if (image.image) {
              @if (image.url) {
                <a
                  class="my-3 inline-block"
                  [class.bg-white]="
                    genericBlock.type === FooterBlockType.Payments
                  "
                  [class.rounded]="genericBlock.type === FooterBlockType.Payments"
                  [class.p-1]="genericBlock.type === FooterBlockType.Payments"
                  [href]="image.url"
                  ><img
                    class="block h-auto max-h-8"
                    [alt]="image.imageAlts | language"
                    [src]="
                      footerStore.requestPath(image.id, genericBlock.id ?? '')
                    "
                /></a>
              } @else {
                <span
                  class="my-3 inline-block"
                  [class.bg-white]="
                    genericBlock.type === FooterBlockType.Payments
                  "
                  [class.rounded]="genericBlock.type === FooterBlockType.Payments"
                  [class.p-1]="genericBlock.type === FooterBlockType.Payments"
                  ><img
                    class="block h-auto max-h-8"
                    [alt]="image.imageAlts | language"
                    [src]="
                      footerStore.requestPath(image.id, genericBlock.id ?? '')
                    "
                /></span>
              }
            }
          }
        </div>
      }
    }
  </div>
} @else {
  <div [attr.data-testid]="'footer-block-' + name()" class="p-5">
    @if (showHeadline() && headline()) {
      <div
        [attr.data-testid]="'footer-block-header-' + name()"
        [style.font-size]="headlineSize() ?? 0 | toFontSize"
        class="mb-2 font-medium uppercase"
        [attr.aria-label]="headline()">
        {{ headline() }}
      </div>
    }
    <div [attr.data-testid]="'footer-block-content'">
      <ng-container *ngTemplateOutlet="children()!"> </ng-container>
    </div>
  </div>
}
